import ABOProfileBGT from "./ABOProfileBGT/ABOProfileBGT";
import ABOProfilePerfHistory from "./ABOProfilePerfHistory/ABOProfilePerfHistory";

const InsightsTab = () => {
  return (
    <div>
      <ABOProfileBGT />
      <ABOProfilePerfHistory />
    </div>
  );
};

export default InsightsTab;
